import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import UICardHeader from 'UIComponents/card/UICardHeader';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIRibbon from 'UIComponents/ribbon/UIRibbon';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import { validUnescapedText } from '../../i18n/utils';
import ValidI18nMessage from '../../i18n/components/ValidI18nMessage';
export default function CollectionCard({
  className,
  collection,
  descriptionI18nKey,
  titleI18nKey,
  maxHeight,
  isLinguineUngated
}) {
  if (!collection.publishedListing) {
    return null;
  }

  return /*#__PURE__*/_jsxs(UICardWrapper, {
    className: className,
    compact: true,
    children: [/*#__PURE__*/_jsx(UIRibbon, {
      use: "calypso",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-common.collections.collectionLabel"
      })
    }), /*#__PURE__*/_jsx(UICardHeader, {
      className: "m-top-4",
      title: isLinguineUngated ? collection.publishedListing.name : validUnescapedText(titleI18nKey, {}, collection.publishedListing.title),
      titleSize: "small"
    }), /*#__PURE__*/_jsx(DescriptionWrapper, {
      maxHeight: maxHeight,
      children: isLinguineUngated ? /*#__PURE__*/_jsx(SanitizedText, {
        body: collection.publishedListing.description,
        WrapperComponent: "span"
      }) : /*#__PURE__*/_jsx(ValidI18nMessage, {
        defaultValue: collection.publishedListing.description,
        message: descriptionI18nKey,
        messageComponent: FormattedHTMLMessage
      })
    })]
  });
}

function DescriptionWrapper({
  children,
  maxHeight
}) {
  if (maxHeight === undefined) {
    return /*#__PURE__*/_jsx(UICardSection, {
      children: children
    });
  }

  return /*#__PURE__*/_jsx(UICardSection, {
    className: "p-bottom-2",
    children: /*#__PURE__*/_jsx(UIExpandableText, {
      onCollapseButtonClick: e => e.preventDefault(),
      onExpandButtonClick: e => e.preventDefault(),
      maxHeight: maxHeight,
      children: children
    })
  });
}